import { Model as r } from "../../../../../model.js";
class i extends r {
  constructor(o) {
    super(), this.validationErrors = o.validationErrors, Object.assign(this, o);
  }
}
export {
  i as ShopTicketModel
};
//# sourceMappingURL=shopTicket.model.js.map
